var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardDetailsActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11318",
    "data-name": "Path 11318",
    d: "M6.538,19.077H4.848A2.365,2.365,0,0,1,2.5,16.769V5.807A2.308,2.308,0,0,1,4.848,3.5H22.733A2.256,2.256,0,0,1,25,5.807v7.5H23.846v-7.5a1.119,1.119,0,0,0-1.113-1.154H4.848A1.188,1.188,0,0,0,3.654,5.807V16.769a1.194,1.194,0,0,0,1.194,1.154h1.69Z",
    transform: "translate(-1.058 -1.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3806",
    "data-name": "Rectangle 3806",
    width: 21.346,
    height: 1.154,
    transform: "translate(2.019 5.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3807",
    "data-name": "Rectangle 3807",
    width: 21.346,
    height: 1.154,
    transform: "translate(2.019 8.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11319",
    "data-name": "Path 11319",
    d: "M30.733,37.077H12.848A2.365,2.365,0,0,1,10.5,34.769V23.807A2.308,2.308,0,0,1,12.848,21.5H30.733A2.256,2.256,0,0,1,33,23.807V34.769a2.262,2.262,0,0,1-2.267,2.308ZM12.848,22.654a1.188,1.188,0,0,0-1.194,1.154V34.769a1.194,1.194,0,0,0,1.194,1.154H30.733a1.154,1.154,0,0,0,1.113-1.154V23.807a1.119,1.119,0,0,0-1.113-1.154Z",
    transform: "translate(-4.442 -9.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3808",
    "data-name": "Rectangle 3808",
    width: 2.885,
    height: 1.154,
    transform: "translate(8.942 23.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3809",
    "data-name": "Rectangle 3809",
    width: 2.885,
    height: 1.154,
    transform: "translate(13.558 23.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3810",
    "data-name": "Rectangle 3810",
    width: 2.885,
    height: 1.154,
    transform: "translate(18.173 23.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3811",
    "data-name": "Rectangle 3811",
    width: 2.885,
    height: 1.154,
    transform: "translate(22.788 23.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11320",
    "data-name": "Path 11320",
    d: "M20.115,32.115H17.231A1.731,1.731,0,0,1,15.5,30.385V29.231A1.731,1.731,0,0,1,17.231,27.5h2.885a1.731,1.731,0,0,1,1.731,1.731v1.154A1.731,1.731,0,0,1,20.115,32.115Zm-2.885-3.462a.577.577,0,0,0-.577.577v1.154a.577.577,0,0,0,.577.577h2.885a.577.577,0,0,0,.577-.577V29.231a.577.577,0,0,0-.577-.577Z",
    transform: "translate(-6.558 -11.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3812",
    "data-name": "Rectangle 3812",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDetailsActive);
export default __webpack_public_path__ + "static/media/cardDetails-active.bfce74d6b8f97661f86030af1f7ffcca.svg";
export { ForwardRef as ReactComponent };